import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import isMeetingInPast from 'owa-timeformat/lib/utils/isMeetingInPast';
import Item from 'owa-service/lib/contract/Item';
import { OwaDate } from 'owa-datetime';

function isMeetingNotFree(meeting: CalendarItem) {
    return meeting.FreeBusyType != 'Free';
}

export function getFutureAdjacentMeetings(item: MeetingRequestMessageType, date: OwaDate): Item[] {
    const adjacentMeetings = (item.AdjacentMeetings && item.AdjacentMeetings.Items) || [];
    return adjacentMeetings.filter(isMeetingNotFree).filter(item => !isMeetingInPast(item, date));
}

export function getFutureConflictingMeetings(
    item: MeetingRequestMessageType,
    date: OwaDate
): Item[] {
    const conflictingMeetings = (item.ConflictingMeetings && item.ConflictingMeetings.Items) || [];
    return conflictingMeetings
        .filter(isMeetingNotFree)
        .filter(item => !isMeetingInPast(item, date));
}
